import glamorous from 'glamorous';
import { css } from 'glamor';

export const Emoji = glamorous.span({
  marginRight: '.5em'
});

const mediaQueries = {
  tablet: '@media (min-width:768px)'
};

const slide = css.keyframes({
  '100%': { right: '25px' }
});

export const Box = glamorous.div({
  display: 'none',
  width: '269px',
  backgroundColor: '#FFFFFF',
  boxShadow: '0 0 8px 0 rgba(0,0,0,0.50)',
  borderRadius: '3px',
  position: 'fixed',
  bottom: '21px',
  padding: '30px 24px 24px',
  right: '-273px',
  zIndex: 1000,
  [mediaQueries.tablet]: {
    animation: `${slide} 0.5s forwards`,
    animationDelay: '0s',
    display: 'block'
  }
});

export const CloseIcon = glamorous.button({
  backgroundColor: 'transparent',
  backgroundImage: 'url(https://cdn.auth0.com/blog/announcements/shape.svg)',
  backgroundRepeat: 'no-repeat',
  backgroundPosition: '50%',
  width: '8px',
  height: '8px',
  border: 'none',
  margin: 0,
  position: 'absolute',
  right: '10px',
  top: '20px',
  WebkitTransform: 'translateY(-50%)',
  transform: 'translateY(-50%)',
  outline: 'none',
  WebkitBoxSizing: 'content-box',
  boxSizing: 'content-box'
});

export const Description = glamorous.p({
  color: '#4A4A4A !important',
  textAlign: 'left',
  fontSize: '14px !important',
  letterSpacing: 0,
  lineHeight: 1.7,
  overflow: 'hidden',
  marginTop: '.6em'
});

export const Link = glamorous.a({
  backgroundColor: '#eb5424',
  borderColor: '#e14615',
  borderRadius: '3px',
  display: 'flex',
  flexWrap: 'wrap',
  alignItems: 'center',
  justifyContent: 'center',
  fontSize: '12px',
  fontWeight: 500,
  color: '#fff !important',
  letterSpacing: '0.8px',
  lineHeight: '25px',
  textAlign: 'center',
  textTransform: 'uppercase',
  height: '40px',
  width: '100%',
  ':hover': {
    color: '#fff',
    backgroundColor: '#CA3F12'
  }
});

export const Title = glamorous.strong({
  color: '#000',
  display: 'block',
  lineHeight: 1.7,
  textAlign: 'left',
  width: '100%'
});

export default {
  Box,
  CloseIcon,
  Description,
  Link,
  Title,
  Emoji
};



// WEBPACK FOOTER //
// ./src/components/Announcement/StyledAnnouncement.js